<!-- eslint-disable max-len -->
<template>
  <div>
    <!-- <j-title-header :options="title"/> -->
    <div class="component-card-report m__t--50">
      <label class="label-report">Jumlah Pegawai Berdasarkan Status</label>
      <j-bar-chart-js
        v-if="showReportTotalPegawaiByStatus"
        :datacollection="datacollectionByStatus"
        :options="optionsByStatus" />

      <v-client-table
        :data="data_table"
        :columns="columns"
        :options="options"
        class="jTable" />
        <!-- <jLoadingTable v-if="!load_first"/> -->
    </div>
    <div class="component-card-report">
      <label class="label-report">Jumlah Pegawai Berdasarkan Pendidikan</label>
      <j-pie-chart-js
        v-if="showReportTotalPegawaiByPendidikan"
        :datacollection="datacollectionByPendidikan"
        :options="optionsByPendidikan" />

      <v-client-table
        :data="data_table_pen"
        :columns="columns_pen"
        :options="options_pen"
        class="jTable" />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import jApiKurikulum from '@/services/jApiKurikulum';
// import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  components: {
    // jLoadingTable,
  },
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Report Pegawai',
      },
      load_first: false,
      data_table: [],
      columns: ['laki_laki', 'perempuan', 'pns', 'non_pns', 'honorer', 'pensiun', 'pindah', 'keluar'],
      options: {
        headings: {
          laki_laki: 'Laki-Laki',
          perempuan: 'Perempuan',
          pns: 'PNS',
          non_pns: 'NON PNS',
          honorer: 'HONORER',
          pensiun: 'PENSIUN',
          pindah: 'PINDAH',
          keluar: 'KELUAR',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [10, 50, 100],
      },

      showReportTotalPegawaiByStatus: false,
      datacollectionByStatus: {
        labels: [],
        datasets: [],
      },
      optionsByStatus: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
            },
          }],
          xAxes: [{
            ticks: {
              beginAtZero: true,
            },
            gridLines: {
              display: true,
            },
          }],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },

      data_table_pen: [],
      columns_pen: ['SD', 'SLTP', 'SLTA', 'D3', 'S1', 'S2', 'S3'],
      options_pen: {
        headings: {
          SD: 'SD',
          SLTP: 'SLTP',
          SLTA: 'SLTA',
          D3: 'D3',
          S1: 'S1',
          S2: 'S2',
          S3: 'S3',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [10, 50, 100],
      },
      showReportTotalPegawaiByPendidikan: false,
      datacollectionByPendidikan: {
        labels: [],
        datasets: [],
      },
      optionsByPendidikan: {
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
    this.totalPegawaiByStatus();
    this.totalPegawaiByPendidikan();
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),

    async totalPegawaiByStatus() {
      const getList = await jApiKurikulum.getTotalPegawaiByStatus();
      const values = Object.values(getList.data.data);
      this.datacollectionByStatus.labels = Object.keys(getList.data.data).map(el => el.replace('_', ' ').toUpperCase());
      this.datacollectionByStatus.datasets = [
        {
          label: 'Laki-laki',
          backgroundColor: '#1392ff',
          data: values.map(el => el.laki_laki),
        },
        {
          label: 'Perempuan',
          backgroundColor: '#f87979',
          data: values.map(el => el.perempuan),
        },
      ];
      this.showReportTotalPegawaiByStatus = true;
      this.data_table = [{
        laki_laki: values.map(el => el.laki_laki).reduce((a, b) => a + b, 0),
        perempuan: values.map(el => el.perempuan).reduce((a, b) => a + b, 0),
        pns: getList.data.data.pns ? getList.data.data.pns.laki_laki + getList.data.data.pns.perempuan : 0,
        non_pns: getList.data.data.non_pns ? getList.data.data.non_pns.laki_laki + getList.data.data.non_pns.perempuan : 0,
        honorer: getList.data.data.honorer ? getList.data.data.honorer.laki_laki + getList.data.data.honorer.perempuan : 0,
        pensiun: getList.data.data.pensiun ? getList.data.data.pensiun.laki_laki + getList.data.data.pensiun.perempuan : 0,
        pindah: getList.data.data.pindah ? getList.data.data.pindah.laki_laki + getList.data.data.pindah.perempuan : 0,
        keluar: getList.data.data.keluar ? getList.data.data.keluar.laki_laki + getList.data.data.keluar.perempuan : 0,
      }];
    },

    async totalPegawaiByPendidikan() {
      const getList = await jApiKurikulum.getTotalPegawaiByPendidikan();
      const values = Object.values(getList.data.data);
      this.datacollectionByPendidikan.labels = Object.keys(getList.data.data);
      this.datacollectionByPendidikan.datasets = [
        {
          label: 'Jumlah Pegawai Berdasarkan Pendidikan',
          data: values,
          backgroundColor: [
            'rgb(255, 99, 132)',
            'rgb(67, 252, 243)',
            'rgb(255, 205, 86)',
            'rgb(75, 219, 58)',
            'rgb(241, 67, 252)',
            'rgb(54, 162, 235)',
            'rgb(0, 231, 203)',
          ],
          hoverOffset: 7,
        },
      ];
      this.showReportTotalPegawaiByPendidikan = true;
      this.data_table_pen = [getList.data.data];
    },
  },
  validations() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/jKepegawaianReport.vue